<template>
  <b-container class="mt-5">
    <b-row>
        <b-col offset="0" cols="12" offset-md="6" md="4">
          <registration-form />
        </b-col>
    </b-row>
  </b-container>
</template>
<script>
import firebase from 'firebase'
import RegistrationForm from '../components/RegistrationForm'

export default {
  components: {
    RegistrationForm
  },
  mounted() {
    const el = document.body;
    el.classList.add("home")
    firebase.auth().onAuthStateChanged(user => {
      if (user) this.$router.push('dashboard')
    })
  },
  destroyed() {
    const el = document.body;
    el.classList.remove("home")
  },
  methods: {
    logout () {
      this.$auth.logout()
    }
  }
}
</script>

<style>
body.home {
  background: url(/img/home.jpg) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  background-size: cover;
  -o-background-size: cover;
}
</style>